import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { setAppElement } from 'react-modal';

import App from './App';
import AuthenticationRoot from './components/AuthContext';
import UnauthenticatedRedirect from './components/UnauthenticatedRedirect';

import { BrowserRouter } from 'react-router-dom';

import './index.css';
import registerServiceWorker, { ServiceWorkerEventSource } from './registerServiceWorker';

import './Extensions';

const eventSource: ServiceWorkerEventSource = new ServiceWorkerEventSource();

setAppElement("#root");

ReactDOM.render(
    <BrowserRouter>
        <AuthenticationRoot>
            <UnauthenticatedRedirect to="/login" passwordTo="/changepassword" push={true}>
                <App serviceWorkerEventSource={eventSource} />
            </UnauthenticatedRedirect>
        </AuthenticationRoot>
    </BrowserRouter>,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker(eventSource);
